import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import FunctionForm from "./FunctionForm.vue";
import { useUpdateFunction } from "./hooks/useUpdateFunction";


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateFunction',
  setup(__props) {

const {
  refUpdateFunction,
  disableSubmit,
  loading,
  visible,
  close,
  submit,
  openUpdate,
  onSubmit,
} = useUpdateFunction();

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ openUpdate: _unref(openUpdate) }))),
    _createVNode(_component_Dialog, {
      visible: _unref(visible),
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
      style: { width: '450px' },
      closable: true
    }, {
      header: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("update.title")), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _ctx.$t('close'),
          icon: "pi pi-times",
          onClick: _unref(close),
          class: "p-button-warning"
        }, null, 8, ["label", "onClick"]),
        _createVNode(_component_Button, {
          loading: _unref(loading),
          disabled: _unref(disableSubmit),
          label: _ctx.$t('create0'),
          icon: "pi pi-save",
          "icon-pos": "right",
          onClick: _unref(submit)
        }, null, 8, ["loading", "disabled", "label", "onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(FunctionForm, {
          ref_key: "refUpdateFunction",
          ref: refUpdateFunction,
          onValidate: _unref(onSubmit)
        }, null, 8, ["onValidate"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})